module.exports = __webpack_public_path__ + "static/media/suavisador.a6a2bce3.jpg";